
import { Injectable } from '@angular/core';
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";

@Injectable()
export class ComponentInteractionService {

  private eventSubject = new Subject<any>();
  private unAthorizedAccessEvtObject=new Subject<any>();
  private sideBarMenuLoadedEvtObject=new Subject<any>();
  private timeSeriedIdChangeForChart=new Subject<string>();

  appRegisteredCompleted$ = this.eventSubject.asObservable();
  unAthorizedAccessEvent = this.unAthorizedAccessEvtObject.asObservable();
  sideBarMenuLoadedCompleted=this.sideBarMenuLoadedEvtObject.asObservable();
  timeSeriedIdChangeForChartEvent=this.timeSeriedIdChangeForChart.asObservable();

  Notify(value: string) {
    return this.eventSubject.next(value);
  }
  NotifyUnAuthorizedAccessEvent()
  {
    return this.unAthorizedAccessEvtObject.next();
  }
  notifySideBarMenuLoadedEvent(featureLoadedData:any){
    return this.sideBarMenuLoadedEvtObject.next(featureLoadedData);
  }

  NotifyTimeseriesIdChangeEvent(timeseriesId:string)
  {
    return this.timeSeriedIdChangeForChart.next(timeseriesId);
  }

}
